/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Dependency injection
 */
import * as React from 'react';
export class Inject extends React.PureComponent {
    render() {
        return null;
    }
}
Inject.isService = true;
